import { render, staticRenderFns } from "./center_4.vue?vue&type=template&id=a3badd42&scoped=true&"
import script from "./center_4.vue?vue&type=script&lang=js&"
export * from "./center_4.vue?vue&type=script&lang=js&"
import style0 from "./center_4.vue?vue&type=style&index=0&id=a3badd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3badd42",
  null
  
)

export default component.exports